import React from "react";

interface ComponentProps {
    name: string;
    size: string;
    color: string;
    clsName?: string;
}

const CustomIcon: React.FC<ComponentProps> = ({
    name,
    size,
    color,
    clsName,
}) => {
    const accent = (color: string) => {
        switch (color) {
            case "primary":
                return "#222";
            case "secondary":
                return "#0982b3";
            case "warning":
                return "#f0cb0c";
            case "success":
                return "#09b209";
            case "error":
                return "#900";
            default:
                return color;
        }
    };
    const fontSize = (size: string) => {
        switch (size) {
            case "xsm":
                return "10px";
            case "sm":
                return "14px";
            case "md":
                return "16px";
            case "xmd":
                return "20px";
            case "lg":
                return "21px";
            case "xlg":
                return "28px";
            default:
                return size;
        }
    };

    return (
        <i
            className={`bfs-${name} ${clsName}`}
            style={{
                color: `${accent(color)}`,
                fontSize: `${fontSize(size)}`,
            }}
        ></i>
    );
};

export default CustomIcon;
